import React from 'react';
import { Hidden, List, ListItem, Stack, Text } from '@origin-digital/ods-core';
import { BLACK_FRIDAY } from '../../typings';
import { RenderDuring } from '../utils/RenderDuring';

const alwaysOnContent = (
  <Stack>
    <Text>
      It's as easy as linking your membership number in the next step. On our Everyday Rewards plan
      you'll get these great benefits:
    </Text>
    <List space="small">
      <ListItem>
        Collect a one-off bonus of 2,500 Everyday Rewards points for each energy type.
      </ListItem>
      <ListItem>
        Plus if you're switching your fuel to us from another retailer you'll collect an additional
        2,500 bonus points for each energy type.
      </ListItem>
      <ListItem>
        All Origin Everyday Rewards plan customers collect 1 Everyday Rewards point for every $1
        (incl GST) charged for usage and supply.
      </ListItem>
      <ListItem>
        Offset greenhouse gas emissions from your electricity or natural gas supply. Our carbon
        offset add-ons are certified by Climate Active. It's as simple as opting-in for either (or
        both) carbon offset add-ons when you sign up to the Origin Everyday Rewards Variable plan.
        Origin Go Zero electricity starts from $1.50 per week and Origin Go Zero Natural Gas starts
        from $1 per week.
      </ListItem>
      <ListItem>
        You'll also earn 2,000 bonus Everyday Rewards points for each Go Zero product you sign up
        to. That's up to 4,000 bonus points.
      </ListItem>
    </List>
  </Stack>
);

// The EDR modal content for Black Friday 2024 MUST be rollback to [Always on] as in Figma after the campaign ends
const blackFriday2024Content = (
  <Stack>
    <Text>
      It's as easy as linking your membership number in the next step. On our Everyday Rewards plan
      you'll get these great benefits:
    </Text>
    <List space="small">
      <ListItem>
        New residential customers can collect 15,000 bonus points for each energy type between 20th
        November - 3rd December 2024.
      </ListItem>
      <ListItem>
        Existing residential customers collect a one-off bonus of 2,500 Everyday Rewards points for
        each energy type.
      </ListItem>
      <ListItem>
        All Origin Everyday Rewards plan customers collect 1 Everyday Rewards point for every $1
        (incl GST) charged for usage and supply.
      </ListItem>
      <ListItem>
        You can play your part and make a difference to the environment. It’s as simple as opting-in
        for either (or both) carbon neutral energy product(s) when you sign up to the Origin
        Everyday Rewards Variable plan. Origin Go Zero Electricity starts from $1.50 per week, and
        Origin Go Zero Natural Gas starts from $1 per week.
      </ListItem>
      <ListItem>
        You’ll also earn 2,000 bonus Everyday Rewards points for each energy type you sign up.
        That’s up to 4,000 bonus points.
      </ListItem>
    </List>
  </Stack>
);

export const GreenExplainerNewModal = (
  <Stack space={['large', 'xlarge']}>
    <Stack data-id="everyday-rewards-explainer-modal">
      {/* EDR logo */}
      <Stack space="none">
        <Hidden above="md">
          <img
            src="https://res.cloudinary.com/originenergy/image/upload/v1602473947/b0c46615e75192e97ca21ccf1dc3cceab808d903.png"
            alt="Everyday Rewards"
            height="72"
          />
        </Hidden>
        <Hidden below="lg">
          <img
            src="https://res.cloudinary.com/originenergy/image/upload/v1602473947/b0c46615e75192e97ca21ccf1dc3cceab808d903.png"
            alt="Everyday Rewards"
            height="96"
          />
        </Hidden>
      </Stack>
      {/* End EDR logo */}
      <RenderDuring
        showDefault={alwaysOnContent}
        showDuring={blackFriday2024Content}
        fromDate={BLACK_FRIDAY.startDate}
        endDate={BLACK_FRIDAY.endDate}
      />
    </Stack>
  </Stack>
);
